export default "__VITE_ASSET__5333ddb8__$_?react__"